import React, { useState } from 'react'; // Importa useState
import { useNavigate } from 'react-router-dom'; 
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';

const BotonMenu = () => {
    const navigate = useNavigate(); 
    return (
        <Row>
                    <Button variant="link" onClick={() => navigate('/calculadoras-financieras')} className="ms-2" style={{paddingLeft:'10px'}}>
                        Ir a Calculadoras
                    </Button> 
        </Row>                              


    );

};

export default BotonMenu;